<template>
  <!-- Modal -->
  <ModalLayout ref="signOffModal" modal-id="signoffModal"
    :loading="isSavableStateLoading" @close="closeModal()">
    <template #modal-header>
        <h5  class="modal-title">
          {{ `Confirm Verification for Item Type - ${data.template_item.item_type.item_type}` }}
        </h5>
    </template>
    <template #modal-body>
      <form @submit.prevent="signOff">
        <div class="row">
          <div class="col-sm-12">
            You are verifying as <b>{{`${initials}`}}</b>. 
            <br>
            Would you like to proceed?
          </div>
        </div>
        <div class="save-toolbar action-row">
          <ActionToolbar :component-state="currentState" 
            toolbar-size="col-md-6"
            :primary-disabled="isSavableStateLoading"
            :success-message="successMessage"
            primary-button-text="Verify"
            :secondary-enabled="false"
            :error-message="formError" />  
        </div>
      </form>
    </template>
  </ModalLayout>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
// @ts-ignore
import ModalLayout from "@/src/components/shared/ModalLayout.vue";
// @ts-ignore
import ActionToolbar from "@/src/components/shared/ActionToolbar.vue";
// @ts-ignore
import { useAppCoreStore } from "@/src/stores/app-core";
// @ts-ignore
import { useChecklistStore } from '@/src/stores/checklist';
// @ts-ignore
import { formatDateTimeET } from "@/src/date-helpers";
import { useSavableState } from '@/src/composables/useSavableState';
import { useModalActions } from '@/src/composables/useModalActions';

const props = defineProps({
  data: { required: true, type: Object },
  itemId: { required: true, type: String },
  matchId: { required: true, type: String }
});

const emit = defineEmits(['close']);

const checklistStore = useChecklistStore();
const appStore = useAppCoreStore();

const {
  formError,
  currentState,
  isSavableStateLoading,
  setSavableStateBlank,
  setSavableStateProcessing,
  setSavableStateSuccess,
  handleFormError,
} = useSavableState();

// Template refs
const signOffModal = ref<InstanceType<typeof ModalLayout> | null>(null);

// Component state
const successMessage = ref<string | null>(null);

const initials = computed(() => appStore.currentUser.profileInfo.full_name);

const { showModal, closeAllModals } = useModalActions(signOffModal, emit);

function closeModal() {
  setSavableStateBlank();
  emit('close');
}

async function signOff() {
  try {
    setSavableStateProcessing();
    const payload = {
      applied_item_id: props.data.id,
      checklist_template_id: props.data.template_id,
      status: props.data.status,
      item_body_instance: props.data.item_body_instance,
      applied_template_id: props.data.applied_template_id,
      match_id: props.matchId,
    };
    let response;
    if (props.data.isDirty)
      response = await checklistStore.updateAndSignOffTemplateItemForMatch(payload);
    else
      response = await checklistStore.signOffTemplateItemForMatch(payload);
    successMessage.value = `Successfully marked as verified at ${formatDateTimeET(response.data.signed_at)} ET.`;
    setSavableStateSuccess();
  } catch (error) {
    handleFormError(error);
  }
}

defineExpose({ showModal, closeModal, closeAllModals });
</script>
